module.exports = __webpack_public_path__ + "img/prepworld.18bb6461.svg";